module.exports = __webpack_public_path__ + "img/21@2x.ed9bf469.png";